
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"80","height":"80"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M47.43 29.01c.544 0 1.187.466 1.928 1.398l19.548 26.077H12.558l11.964-16.05c.547-.768 1.15-1.152 1.805-1.152.546 0 1.038.266 1.475.8l5.355 7.224 11.907-16.47c.955-1.218 1.743-1.827 2.366-1.827zm-31.58-5.495a4.759 4.759 0 014.757 4.762 4.76 4.76 0 01-4.756 4.762 4.76 4.76 0 01-4.757-4.762 4.76 4.76 0 014.757-4.762z","fill":"#767676","fill-rule":"evenodd"}})])
          )
        }
      }
    